import React from "react";
import Table from 'react-bootstrap/Table';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import './PropertyList.css';

const flattenJSON = (obj = {}, res = {}, extraKey = '') => {
    for (let key in obj) {
        if (typeof obj[key] !== 'object') {
            res[extraKey + key] = obj[key];
        } else {
            flattenJSON(obj[key], res, `${extraKey}${key}.`);
        };
    };
    return res;
}

const copyJSON = (obj) => {
    let jsonString = JSON.stringify(obj, null, 2);
    navigator.clipboard.writeText(jsonString);
    toast.info("JSON copied to clipboard", { autoClose: 1000 });
}

function PropertyRow(props) {
    const [expand, setExpand] = React.useState(false);

    let depth = props.depth ?? 0;
    let indentStlye = {paddingLeft: (depth * 24) + "px"};
    let obj = props.obj;
    let key = props.k;
    if (typeof obj[key] == "object" && obj[key] != null) {
        if (!expand) {
            let childKeys = "";
            if (props.obj[key]) {
                if (props.obj[key].constructor === Array) {
                    childKeys = props.obj[key].length + " items";
                } else {
                    childKeys = Object.keys(props.obj[key]).sort();
                    if (childKeys.length > 10)
                        childKeys = childKeys.slice(0, 10).join(", ") + "...";
                    else
                        childKeys = childKeys.slice(0, 10).join(", ")          
                }
            }
            return <tr key={key + '-a'} onClick={() => setExpand(true)}><td style={indentStlye}><img src="plus.png" alt="+" />{key}</td><td className="preview">{childKeys}</td></tr>
        } else {
            return <>
            <tr key={key + '-a'} onClick={() => setExpand(false)}><td style={indentStlye}><img src="minus.png" alt="-" />{key}</td><td></td></tr>
            <ChildPropertyList key={key + '-b'} obj={props.obj[key]} depth={depth+1} />
            </>;
        }
    } else {
        let value = obj[key];
        let style = {};
        if (value === null) {
            value = "<null>";
            style = {
                color: "darkred"
            }
        }
        return <tr key={key}><td style={indentStlye}>{key}</td><td style={style}>{value.toString()}</td></tr>;
    }
}

function ChildPropertyList(props) {
    if (props.obj === null)
        return <div></div>;

    let keys = Object.keys(props.obj);
    if (props.obj.constructor !== Array) {
        keys = Object.keys(props.obj).sort();
    }
    let nestedKeys = keys.filter(x => typeof props.obj[x] == "object");
    let topKeys = keys.filter(x => typeof props.obj[x] != "object");
    return <>
        {topKeys.map((k) => <PropertyRow obj={props.obj} key={k} k={k} depth={props.depth} />)}
        {nestedKeys.map((k) => <PropertyRow obj={props.obj} key={k} k={k} depth={props.depth} />)}
        </>;
}

function FoldablePropertyList(props) {
    let keys = Object.keys(props.obj).sort();
    let nestedKeys = keys.filter(x => typeof props.obj[x] == "object");
    let topKeys = keys.filter(x => typeof props.obj[x] != "object");
    return <Table className="property-list">
        <thead>
            <tr><th>Property</th><th>Value</th></tr>
        </thead>
        <tbody>
            {topKeys.map((k) => <PropertyRow obj={props.obj} key={k} k={k} />)}
            {nestedKeys.map((k) => <PropertyRow obj={props.obj} key={k} k={k} />)}
        </tbody>
    </Table>;
}

function FlatPropertyList(props) {
    let flatObj = flattenJSON(props.obj);
    return <Table className="property-list">
        <thead>
            <tr><th>Property</th><th>Value</th></tr>
        </thead>
        <tbody>
            {Object.keys(flatObj).sort().map((k) => <tr key={k}><td>{k}</td><td>{flatObj[k].toString()}</td></tr>)}
        </tbody>
    </Table>;
}

function PropertyList(props) {
    const [flatten, setFlatten] = React.useState(false);

    if (props.obj) {
        return <div>
            <button className="copy-json-button" onClick={() => {copyJSON(props.obj)}}><img src="app-json-icon.png" alt="Copy" />Copy</button>
            <Form.Check type="switch" className="flatten-button" label="Flat View" checked={flatten} onChange={(e) => {setFlatten(e.target.checked)}} />
            {flatten ? 
                <FlatPropertyList obj={props.obj} />
                :
                <FoldablePropertyList obj={props.obj} />
            }
        </div>;
    }
    return <Spinner animation="border" />;
}

export default PropertyList;